// Delegated scope exposed by the MAP Coordinator app registration
// (machina-map-coordinator-dev). Requesting it at login makes the acquired access
// token valid for MAP Coordinator calls on behalf of the signed-in user.
export const MAP_COORDINATOR_SCOPE =
  process.env.NEXT_PUBLIC_MAP_COORDINATOR_SCOPE ||
  "api://1a1ea25c-4591-4cb1-aaaa-cb0afe3d02d7/user_impersonation";

// Scopes for both the authorize redirect and the code exchange — the two requests
// must ask for the same audience or the token endpoint issues a token the user
// never consented to.
export const LOGIN_SCOPES = ["openid", "profile", "email", "offline_access", MAP_COORDINATOR_SCOPE];
